import type { MonospaceSingleRelationField, MonospaceSingleRelationFieldMeta } from '#layers/data-model';
import { RStoreSchema } from '#imports';

interface StudioSingleRelationField extends MonospaceSingleRelationField {
	isStudioOnly?: boolean;
}

export const SingleRelationField = RStoreSchema.withItemType<StudioSingleRelationField>().defineCollection({
	name: 'MonospaceSingleRelationField',
	scopeId: 'monospace-default',
	meta: {
		defaultFields: ['id', 'apiName', 'isNullable', 'isList', 'oppositeCollectionId', 'collectionId', 'constraintId', 'oppositeRelationFieldId'],
		useProjectSlug: true,
	},
});

export const SingleRelationFieldMeta = RStoreSchema.withItemType<MonospaceSingleRelationFieldMeta>().defineCollection({
	name: 'MonospaceSingleRelationFieldMeta',
	scopeId: 'monospace-default',
	getKey: (item) => item.fieldId,
	meta: {
		defaultFields: ['fieldId', 'description', 'typeTemplateId', 'typeOptions', 'inputId', 'inputOptions', 'displayId', 'displayName', 'displayOptions', 'isHidden', 'sort', 'oppositeJunctionRelationFieldId'],
		useProjectSlug: true,
		connect: {
			fieldId: ['field', 'id'],
		},
	},
});
